import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon ,MDBRow, MDBCol,MDBDataTable    } from 'mdbreact';
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip ,PageHeader  } from 'antd';
import Axios from 'axios'

import adminfaculty from '../adminfaculty/adminfaculty';
//import Modalarticletyps from './Modalarticletypes';
import { URL,api } from '../../api';
import Modaladdexpert from './Modaladdexpert';
import Modaleditexpert from './Modaleditexpert';
import Modaladdroompresent from '../Modaladdroompresent';
import Modaladdarticalpresent from '../Modaladdarticalpresent';
import Modaladdexperpresent from '../Modaladdexperpresent';
import Modalreportscorearticalpresent from '../Modalreportscorearticalpresent';




export default class Superadminprintregisteruniversity extends Component {

    constructor(props) {
        super(props);
        this.state = {
            university:[]
        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
         this.list = this.list.bind(this);
      }


    componentDidMount() {
        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
    
        }

        setTimeout(() => {
           
          api.get('registercon/selectprintuniversity')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ university: res.data})
           }) 
         }, 0);

      }


      list() {

        setTimeout(() => {
          api.get('registercon/selectroompresentlist')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
           }) 
         }, 0);

      }


      updateat(){
        setTimeout(() => {
           
          api.get('registercon/selectregisterall')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 
       }, 0);
      }



    render() {


      const datast = {
        columns: [
          {
            label: 'ลำดับ',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'มหาวิทยาลัย',
            field: 'name_expert',
            sort: 'name_expert',
            width: 150
          },
          {
            label: 'จำนวนลงทะเบียน',
            field: 'name_expert2',
            sort: 'name_expert2',
            width: 150
          },
          {
            label: 'พิมพ์รายชื่อ',
            field: 'print',
            sort: 'print',
            width: 150
          },
         
        //   {
        //     label: 'จัดการผู้ทรงคุณวุฒิ',
        //     field: 'name_admin2',
        //     sort: 'name_admin2',
        //     width: 150
        //   },
        //   {
        //     label: 'พิมพ์ชื่อบทความ',
        //     field: 'print',
        //     sort: 'print',
        //     width: 150
        //   },
          
      
        ],
  
  
        rows: [...this.state.university.map((data, i) => (
          {
             list: <>{i+1}</>,
             name_expert: <>{data.name_university}</>,
             name_expert2: <>{data.Num}</>,
           
               print: <><a href={`https://scitech.kpru.ac.th/csrm2025/system/conferencekpru/report/reportregisteruniversity.php?id_university=${data.id_university}&name_university=${data.name_university}`}  target="_blank" > <MDBBtn color="mdb-color" size='sm'>พิมพ์</MDBBtn></a></>,

            //  name_admin2: <><Modaladdexperpresent id_roompresent={data.id_roompresent} name_room={data.name_room}	 roompresent_date={data.roompresent_date} /></>,
            //  print: <></>,
            //  name_admin2: <><Modaleditexpert id_expert={data.id_expert} list={this.list} /></>,
            
          }
         ))]
    
        };
            const persons = <MDBDataTable
          // searching ={true}
            searchLabel="ค้นหา ชื่อ"
            striped
            bordered
            small 
            entries={50}
          // entriesOptions={["10", "20"]}
            order={["age", "desc"]}
            data={datast}
            entriesLabel="จำนวนที่แสดง "
            infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
            paginationLabel={["ย้อนกลับ", "ถัดไป"]}
            responsive 
            sortRows={['random']}
            theadColor="grey lighten-1"
            />

        return (
            <MDBContainer fluid>
            <div>
        
            {localStorage.getItem('admin_type') === 'expertbn' ?<>
              <p className="text-right">สวัสดีคุณ : {localStorage.getItem('nameuser')} (บรรณาธิการ)</p>
             </>:<>
              <p className="text-right font-weight-bold">สวัสดีคุณ : {localStorage.getItem('nameuser')} (ผู้ดูแลระบบกลาง)</p>
             </>}
            {/* <p className="text-right">การประชุมวิชาการระดับชาติ สำหรับนักศึกษา ครั้งที่ 3 สถาบันวิจัยและพัฒนา มหาวิทยาลัยราชภัฏกำแพงเพชร</p>  */}
         
                <MDBAlert color="secondary" >
                   {/* <h2> <MDBIcon far icon="file-alt" /> ข้อมูลผู้ทรงคุณวุฒิ</h2> */}    
                    <MDBRow >
                        <MDBCol md="8">
                        <PageHeader
                            className="site-page-header"
                          // onBack={() => null}
                            title="พิมพ์ใบรายชื่อแต่ละมหาวิทยาลัย"
                            subTitle="พิมพ์ใบรายชื่อ"
                            avatar={{ src: 'https://cdn-icons-png.flaticon.com/512/4514/4514882.png' }}
                        />
                        </MDBCol>
                        <MDBCol md="4">
                       
                        </MDBCol>
                    </MDBRow>
                </MDBAlert>
                 {persons}


            </div>
            </MDBContainer>
        )
    }
}
